document.addEventListener('DOMContentLoaded', function(){
  var searchInputs = document.querySelectorAll('input[type=search]');
  searchInputs.forEach(function(input){
    var timeout;
    var box = document.createElement('div');
    box.className = 'search-suggestions';
    box.style.position='absolute';
    box.style.zIndex=999;
    input.parentNode.appendChild(box);

    input.addEventListener('input', function(){
      clearTimeout(timeout);
      var q = this.value.trim();
      if(q.length < 2){ box.innerHTML=''; box.style.display='none'; return; }
      timeout = setTimeout(function(){
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[offset]=0&resources[limit]=6')
        .then(r=>r.json())
        .then(data=>{
          var html = '';
          var products = data.resources.results.products;
          if(products && products.length){
            html += '<ul>';
            products.forEach(function(p){
              html += '<li><a href="'+p.url+'"><img src="'+p.image+'" style="width:48px;height:48px;object-fit:cover;margin-left:8px;border-radius:6px;">'+p.title+'</a></li>';
            });
            html += '</ul>';
            box.innerHTML = html;
            box.style.display='block';
          } else {
            box.innerHTML = '<div class="no-results">לא נמצאו מוצרים</div>';
            box.style.display='block';
          }
        });
      }, 220);
    });
  });
});
